// Successful configuration commands invalidate display reads, not authorization state.
type DisplayRead = "storages" | "environment" | "secure-access";
const listeners = new Set<(read: DisplayRead) => void>();
export function onConsoleConfigurationChanged(listener: (read: DisplayRead) => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function notifyConsoleConfigurationChanged(path: string) {
  const read: DisplayRead | null =
    path === "/storage-registrations" || path === "/local-gateway-setup-handoffs" ||
      (path.startsWith("/storages") && path !== "/storages/runtime-status:batch")
      ? "storages"
      : path === "/console-bff/secure-access"
        ? "secure-access"
        : path === "/kintone-environment/registration" ||
            path.startsWith("/kintone-environment/switch-operations") ||
            (path.startsWith("/service-subscription") &&
              path !== "/service-subscription/plan-change-estimates" &&
              path !== "/service-subscription/billing-portal-sessions")
          ? "environment"
          : null;
  if (read) listeners.forEach(listener => listener(read));
}
